import {motion} from "framer-motion";
import styles from './Services.module.css';
import React from "react";

export default function Services() {
    // Animations for each block
    const variants = [
        {initial: {x: -40, opacity: 0}, animate: {x: 0, opacity: 1}}, // left
        {initial: {y: 40, opacity: 0}, animate: {y: 0, opacity: 1}},  // middle
        {initial: {x: 40, opacity: 0}, animate: {x: 0, opacity: 1}},  // right
    ];
    const delays = [0, 0.15, 0.3];

    return (
        <section className={styles.servicesSection}>
            <div className={styles.container}>
                <div className={styles.grid}>
                    {/* Chopsticks */}
                    <motion.div
                        initial={variants[0].initial}
                        whileInView={variants[0].animate}
                        viewport={{once: true}}
                        transition={{duration: 0.7, delay: delays[0], ease: [0.23, 1, 0.32, 1]}}
                        className={styles.chopsticksContainer}
                    >
                        <img
                            src="https://cdn.prod.website-files.com/67f441d25cb5816471a3d604/681aac5e1725cf67b59f1589_Chopsticks.png"
                            alt="Chopsticks"
                            className={styles.chopsticksImage}
                            draggable={false}
                        />
                    </motion.div>

                    {/* Find Us */}
                    <motion.div
                        initial={variants[1].initial}
                        whileInView={variants[1].animate}
                        viewport={{once: true}}
                        transition={{duration: 0.7, delay: delays[1], ease: [0.23, 1, 0.32, 1]}}
                        className={styles.findUsContainer}
                    >
                        <div className={styles.title}>
                            Find Us
                        </div>
                        <div className={styles.infoText}>
                            2960 Shallowford Rd # 311, Marietta, GA 30066
                            <br/>
                            (678) 560-0015
                            <br/>
                            <span className={styles.email}>email@example.com</span>
                        </div>
                    </motion.div>

                    {/* Our Hours */}
                    <motion.div
                        initial={variants[2].initial}
                        whileInView={variants[2].animate}
                        viewport={{once: true}}
                        transition={{duration: 0.7, delay: delays[2], ease: [0.23, 1, 0.32, 1]}}
                        className={styles.hoursContainer}
                    >
                        <div className={styles.title}>
                            Our Hours
                        </div>
                        <ul className="list-unstyled">
                            <li style={{ color: '#f7efd7', fontSize: '1.1rem' }}>Monday: 4:30 PM - 10:00 PM</li>
                            <li style={{ color: '#f7efd7', fontSize: '1.1rem' }}>Tuesday: 4:30 PM - 10:00 PM</li>
                            <li style={{ color: '#f7efd7', fontSize: '1.1rem' }}>Wednesday: 4:30 PM - 10:00 PM</li>
                            <li style={{ color: '#f7efd7', fontSize: '1.1rem' }}>Thursday: 4:30 PM - 10:00 PM
                                November 27 - Closed</li>
                            <li style={{ color: '#f7efd7', fontSize: '1.1rem' }}>Friday: 4:30 PM - 10:00 PM</li>
                            <li style={{ color: '#f7efd7', fontSize: '1.1rem' }}>Saturday: 4:30 PM - 10:00 PM</li>
                            <li style={{ color: '#f7efd7', fontSize: '1.1rem' }}>Sunday: 4:30 PM - 9:30 PM</li>
                        </ul>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
